module.exports = ".tableHeaderRow {\r\n    z-index: 999;\r\n}"